import { Component } from '@angular/core';


export class SkyDatepickerDemoComponent {
  public minDate: Date;
  public maxDate: Date;
  public selectedDate: Date;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-datepicker-demo',
  template: `<div style="max-width: 50%">
  <sky-datepicker #picker>
    <input
      [(ngModel)]="selectedDate"
      [skyDatepickerInput]="picker"
      [minDate]="minDate"
      [maxDate]="maxDate"
      #date="ngModel"/>
  </sky-datepicker>
  <div
    class="sky-error-label"
    *ngIf="date.errors && date.errors.skyDate && (date.dirty || date.touched)">

    <span [hidden]="!date.errors.skyDate.invalid">
      Please enter a valid date.
    </span>

    <span [hidden]="!date.errors.skyDate.minDate">
      Date is prior to minimum date range.
    </span>

    <span [hidden]="!date.errors.skyDate.maxDate">
      Date is after maximum date range.
    </span>
  </div>
</div>

<div>
  Selected date is {{selectedDate}}
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
